import styled from 'styled-components'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import colors from '@settings/styleSettings'

export const ModalContainer = styled.div`
  background: #fff;
  border-radius: 14px;
  width: 100%;
  max-width: 520px;
  padding: 20px 20px 16px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  box-shadow: 0 16px 32px rgba(0,0,0,0.18);
  box-sizing: border-box;
`

export const CloseButton = styled.button`
  align-self: flex-end;
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 20px;
  color: #4a4a4a;
`

/* Linha com ícone + conteúdo à direita */
export const Row = styled.div`
  display: grid;
  grid-template-columns: 28px 1fr;
  column-gap: 10px;
  align-items: center;
  width: 100%;
`

export const Icon = styled.span`
  color: #6b7280;
  font-size: 20px;
  justify-self: center;
`

/* Conteúdo principal da linha (coluna da direita) */
export const Col = styled.div`
  width: 100%;
`

/* Label pequena (ex.: “Local”) alinhada ao conteúdo */
export const SubLabel = styled.div`
  font-size: 13px;
  color: #6B7280;
  margin-bottom: 4px;
`

/* Select com fundo cinza e borda suave */
export const StyledSelect = styled(Select)({
  width: '100%',
  height: 44,
  borderRadius: 10,
  backgroundColor: colors.softGrayBackground,
  '& .MuiSelect-select': {
    padding: '12px 14px',
    display: 'flex',
    alignItems: 'center',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: '1px solid #E5E7EB',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: '#E5E7EB',
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: '#D1D5DB',
  },
})

export const StyledMenuItem = styled(MenuItem)({
  '&.Mui-selected': {
    backgroundColor: `${colors.primary} !important`,
    color: '#fff !important',
  },
  '&.Mui-selected:hover': {
    backgroundColor: `${colors.secondary} !important`,
  },
})

/* Data (input simples visualmente consistente) */
export const CustomInputDateModal = styled.input`
  width: 160px;
  height: 38px;
  border-radius: 10px;
  border: 1px solid ${(props) => (props.error ? '#ef4444' : '#E5E7EB')};
  background: ${colors.softGrayBackground};
  padding: 0 10px;
  outline: none;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  box-sizing: border-box;
`

/* Grid para Início / Fim, sem recuos */
export const TimeGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  width: 100%;
`

export const TimeBox = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  background: ${colors.softGrayBackground};
  border: 1px solid #E5E7EB;
  border-radius: 10px;
  height: 44px;
  padding: 0 10px;
  box-sizing: border-box;
`

export const TimeLabel = styled.span`
  color: #9CA3AF;
  font-weight: 600;
  font-size: 13px;
  min-width: 44px;
`

export const StyledInput = styled.input`
  border: none;
  outline: none;
  background: transparent;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  flex: 1;
  min-width: 120px;
  box-sizing: border-box;

  &::-webkit-calendar-picker-indicator { display: none; }
  &::-webkit-clear-button { display: none; }
  &::-webkit-inner-spin-button { display: none; }
  &::-webkit-outer-spin-button { display: none; }
`
